import React from 'react';
import ModernTemplate from './Templates/ModernTemplate';
import ProfessionalTemplate from './Templates/ProfessionalTemplate';
import CreativeTemplate from './Templates/CreativeTemplate';
import MinimalTemplate from './Templates/MinimalTemplate';

export default function ResumePreview({ resumeData, templateType = 'modern', zoom = 1 }) {
	const Template = {
		modern: ModernTemplate,
		professional: ProfessionalTemplate,
		creative: CreativeTemplate,
		minimal: MinimalTemplate
	}[String(templateType).toLowerCase()] || ModernTemplate;

	return (
		<div className="w-full flex justify-center">
			<div
				id="resume-preview"
				className="bg-white shadow border print:shadow-none print:border-0"
				style={{
					transform: `scale(${zoom})`,
					transformOrigin: 'top center',
					width: '816px', // ~ letter width at 96dpi
					minHeight: '1056px' // ~ letter height at 96dpi
				}}
			>
				<Template resumeData={resumeData} />
			</div>
		</div>
	);
}


